import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// components
import LoadingSpinner from "module/common/components/LoadingSpinner";
// utils
import { selectAuthVerifyStatus } from "module/main/store/auth/selectors";
import { useSelector } from "react-redux";
var VerifyStep = function () {
    var verifyStatus = useSelector(selectAuthVerifyStatus);
    if (verifyStatus === "loading")
        return _jsx(LoadingSpinner, {});
    return (_jsxs(_Fragment, { children: [_jsx("h3", { children: "Please verify your account" }), _jsx("p", { className: "text-gray", children: "A verification link has been sent to your email." })] }));
};
export default VerifyStep;
